import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'searchInfo' })
export class SearchInfoPipe implements PipeTransform {
    transform(arr: any[], txt: string): any {
        if (!arr) return []
        const res = arr.filter(item => {
            if (!txt) txt = ""
            let str = JSON.stringify(item).toLowerCase()
            const idx = str.indexOf(txt.toLowerCase())
            return (idx !== -1)
        })
        return res
    }
}
